import type { routes } from '@semios/app-platform-banyan-route-definitions'
import { buildZoneCrops, type TZoneCrops } from 'App/dashboards/_utils/zoneCrops'
import { useEffect, useMemo, useState } from 'react'
import { apiFetch } from 'utils/apiFetch'
import { captureFrontendError } from 'utils/captureFrontendError'

type TZones = routes.IrrigationZoneCrops.Response['zones']

const NO_ZONES: TZones = []

export const useZoneCrops = (propertyIds: number[]): TZoneCrops => {
  const propertyIdsKey = propertyIds.join('|')

  const [loaded, setLoaded] = useState<{ propertyIdsKey: string; zones: TZones }>({
    propertyIdsKey: '',
    zones: NO_ZONES,
  })

  useEffect(() => {
    if (!propertyIds.length) return

    let cancelled = false

    apiFetch({ url: '/irrigation/zone-crops', body: { propertyIds } })
      .then((res) => {
        if (!cancelled) setLoaded({ propertyIdsKey, zones: res.zones })
      })
      .catch((error) => {
        if (cancelled) return

        setLoaded({ propertyIdsKey, zones: NO_ZONES })

        captureFrontendError(error, { extra: { message: 'Water dashboards zone crops fetch failed' } })
      })

    return () => {
      cancelled = true
    }
  }, [propertyIdsKey])

  const zones = loaded.propertyIdsKey === propertyIdsKey ? loaded.zones : NO_ZONES

  return useMemo(() => buildZoneCrops(zones), [zones])
}
